export default "__VITE_ASSET__HWu57q8Y__"